import React from 'react'

type Props = {
  currentPage: number
  pagesCount: number
  onPageChange: (page: number) => void
}

const WINDOW = 2 // pages shown either side of current

const Pagination: React.FC<Props> = ({currentPage, pagesCount, onPageChange}) => {
  if (pagesCount <= 1) return null

  const prev = () => currentPage > 1 && onPageChange(currentPage - 1)
  const next = () => currentPage < pagesCount && onPageChange(currentPage + 1)

  // Build the list of page numbers / ellipsis markers to render
  const pages: (number | 'ellipsis-start' | 'ellipsis-end')[] = []

  const rangeStart = Math.max(2, currentPage - WINDOW)
  const rangeEnd = Math.min(pagesCount - 1, currentPage + WINDOW)

  pages.push(1)
  if (rangeStart > 2) pages.push('ellipsis-start')
  for (let i = rangeStart; i <= rangeEnd; i++) pages.push(i)
  if (rangeEnd < pagesCount - 1) pages.push('ellipsis-end')
  if (pagesCount > 1) pages.push(pagesCount)

  return (
    <div className='col-12 mt-10 card p-3'>
      <div className='text-center'>
        <nav>
          <ul className='pagination justify-content-center'>
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <a className='page-link' onClick={prev} style={{cursor: 'pointer'}}>
                &laquo;
              </a>
            </li>

            {pages.map((p, i) =>
              p === 'ellipsis-start' || p === 'ellipsis-end' ? (
                <li key={p} className='page-item disabled'>
                  <span className='page-link'>…</span>
                </li>
              ) : (
                <li key={p} className={`page-item ${currentPage === p ? 'active' : ''}`}>
                  <a
                    className='page-link'
                    onClick={() => onPageChange(p)}
                    style={{cursor: 'pointer'}}
                  >
                    {p}
                  </a>
                </li>
              )
            )}

            <li className={`page-item ${currentPage === pagesCount ? 'disabled' : ''}`}>
              <a className='page-link' onClick={next} style={{cursor: 'pointer'}}>
                &raquo;
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  )
}

export default Pagination
